export default __webpack_public_path__ + "static/media/drink-evening.6eeb3582.svg";